import React from 'react';
import '../less/index.less'
import hero_img from '../img/hero_img.png';
import diia_logo from '../img/diia_logo.svg';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import AdditionalProduct from '../../../../../auxiliary-components/shared/AdditionalProductBlock';
import QuestionsNew from '../../../../../auxiliary-components/shared/QuestionsNew';
import additionalCards from '../enums/additional_cards.json'
import { personalDataAppLink, personalDataTelegramBotLink, personalDataTelegramLink, personalDataViberBotLink } from '../../../../../services/urls/urls';
import questionsItems from '../enums/questions_items.json'

export default function template() {
  const page = 'personal-data';

  const hero_data = {
    title: 'PERSONAL_DATA_NEW_HERO_TITLE',
    text: 'PERSONAL_DATA_NEW_HERO_TEXT',
    logo: diia_logo
  }

  return (
    <div className="personal-data">
      <Hero
        data={hero_data}
        img={hero_img}
        page={page}
        imgBottom
      />
      <div className="content">
        <>
          <div className="how-update">
            <div className="container">
              <h2 className="how-update__title">{this.l10n('PERSONAL_DATA_NEW_HOW_UPDATE_TITLE')}</h2>
              <div className="how-update__subtitle">{this.l10n('PERSONAL_DATA_NEW_HOW_UPDATE_SUBTITLE')}</div>
              <ol className="how-update__list">
                <li>{this.l10n('PERSONAL_DATA_NEW_HOW_UPDATE_LIST_TEXT_01')}</li>
                <li>{this.l10n('PERSONAL_DATA_NEW_HOW_UPDATE_LIST_TEXT_02')}</li>
                <li>{this.l10n('PERSONAL_DATA_NEW_HOW_UPDATE_LIST_TEXT_03')}</li>
                <li>{this.l10n('PERSONAL_DATA_NEW_HOW_UPDATE_LIST_TEXT_04')}</li>
                <li>{this.l10n('PERSONAL_DATA_NEW_HOW_UPDATE_LIST_TEXT_05')}</li>
              </ol>
            </div>
          </div>
          <div className="update-data">
            <div className="container">
              <h2 className="update-data__title">{this.l10n('PERSONAL_DATA_NEW_UPDATE_DATA_TITLE')}</h2>
              <div className="update-data__body">
                <div className="update-data__item item-update-data">
                  <div className="item-update-data__title">{this.l10n('PERSONAL_DATA_NEW_UPDATE_DATA_ITEM_01_TITLE')}</div>
                  <div className="item-update-data__text">
                    <a href={personalDataAppLink} target="_blank" rel="noopener noreferrer" className="item-update-data__link">{this.l10n('PERSONAL_DATA_NEW_UPDATE_DATA_ITEM_01_LINK')}</a>
                  </div>
                </div>
                <div className="update-data__item item-update-data">
                  <div className="item-update-data__title">{this.l10n('PERSONAL_DATA_NEW_UPDATE_DATA_ITEM_02_TITLE')}</div>
                  <div className="item-update-data__text">
                    <a href={personalDataTelegramLink} target="_blank" rel="noopener noreferrer" className="item-update-data__link">{this.l10n('PERSONAL_DATA_NEW_UPDATE_DATA_ITEM_02_LINK')}</a>
                  </div>
                </div>
                <div className="update-data__item item-update-data">
                  <div className="item-update-data__title">{this.l10n('PERSONAL_DATA_NEW_UPDATE_DATA_ITEM_03_TITLE')}</div>
                  <div className="item-update-data__text">
                    <a href={personalDataViberBotLink} target="_blank" rel="noopener noreferrer" className="item-update-data__link">{this.l10n('PERSONAL_DATA_NEW_UPDATE_DATA_ITEM_03_LINK_01')}</a> <span>{this.l10n('PERSONAL_DATA_NEW_UPDATE_DATA_03_TEXT')}</span> <a href={personalDataTelegramBotLink} target="_blank" rel="noopener noreferrer" className="item-update-data__link">{this.l10n('PERSONAL_DATA_NEW_UPDATE_DATA_ITEM_03_LINK_02')}</a>
                  </div>
                </div>
                <div className="update-data__item item-update-data">
                  <div className="item-update-data__title">{this.l10n('PERSONAL_DATA_NEW_UPDATE_DATA_ITEM_04_TITLE')}</div>
                  <div className="item-update-data__text">
                    <a href="/branches" target="_self" className="item-update-data__link" onClick={e => this.navigate('/branches', e)}>{this.l10n('PERSONAL_DATA_NEW_UPDATE_DATA_ITEM_04_LINK')}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <AdditionalProduct
            items={additionalCards}
            title={'PERSONAL_DATA_NEW_ADDITIONAL_PRODUCT_TITLE'}
            page={page}
          />
          <QuestionsNew
            title={'PERSONAL_DATA_NEW_QUESTIONS_BLOCK_TITLE'}
            items={questionsItems}
          />
        </>
      </div>
    </div>
  );
}
